import { FunctionComponent } from "react";
import CardSection from "@components/core/section/CardSection";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import LinkButton from "@components/core/links/LinkButton";
import { ROUTES } from "@routes/Routes";

interface PositioningErrorProps {
  code: string;
  className?: string;
}

const PositioningError: FunctionComponent<PositioningErrorProps> = ({
  code,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <CardSection
      title={t(`errorPage.code.${code}.title`)}
      className={`app-positioning-error text-center ${className}`}
    >
      <>
        <p>{parse(t(`errorPage.code.${code}.message`))}</p>
        <LinkButton
          to={ROUTES.extranet.home.generate()}
          text={t("buttons.back")}
        />
      </>
    </CardSection>
  );
};

export default PositioningError;
